import routerOptions0 from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@18.19.127_@vue+compiler-sfc@3.5.41__72c8f0ae9b28338273d017ae83616528/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/src/gmp-swa/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}